import { Grid } from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { hearingIdentificationInit } from 'types/hearing-identification.type'
import { HearingSummaryType } from 'types/hearing-summary.type'
import { validateField } from 'utils/validate.util'
import { FieldAssign } from './components/FieldAssign'
import { Header } from './components/Header'
import { SummaryData } from './components/SummaryData'
import dayjs from 'dayjs'
import { AttachedFileGroup } from 'components/HearingSummary/components/AttachedFileGroup'
import { StyledPrintContent } from 'pages/DownloadHearing'

export type HearingSummaryProps<T> = { data: T }

const HearingSummary: React.FC<HearingSummaryProps<HearingSummaryType>> = ({ data }) => {
  const { dadosGerais, identAdolescente, promotor } = data

  const hearingDateField = dadosGerais ? validateField(dadosGerais.dataOitiva) : ''
  const responsibleForField = dadosGerais
    ? validateField(dadosGerais.nomeResponsavelAdolescente)
    : ''
  const adolescente = identAdolescente ? identAdolescente : hearingIdentificationInit
  const lawyerNameField = dadosGerais ? validateField(dadosGerais.nomeAdvogado) : ''
  const identificationName = adolescente
    ? adolescente.nomeSocial
      ? validateField(adolescente.nomeSocial)
      : validateField(adolescente.nome)
    : ''
  const extendedDateField = `Rio de Janeiro${
    hearingDateField ? `, ${dayjs(hearingDateField).format('DD/MM/YYYY')}` : ''
  }`

  return (
    <>
      <Header data={data} />
      <SummaryData data={data} />
      <Grid container spacing={1}>
        <Grid item xs={12} sx={{ mt: 2, mb: 2 }}>
          <Label text='Sem mais, e por expressão da verdade, seguem as assinaturas:' />
        </Grid>
        <Grid item xs={12} sx={{ mt: 2, mb: 2 }} display='flex' justifyContent='center'>
          <Label text={extendedDateField} bold />
        </Grid>
      </Grid>
      {promotor && (
        <Grid container spacing={1}>
          <FieldAssign>
            <Label text={validateField(promotor.nome)} />
            <Label text={validateField(promotor.cargo)} />
            <Label text={`Matrícula: ${validateField(promotor.matricula)}`} />
          </FieldAssign>
        </Grid>
      )}
      <Grid container spacing={1}>
        <FieldAssign name={lawyerNameField} />
      </Grid>
      <Grid container spacing={1}>
        <FieldAssign name={responsibleForField} />
      </Grid>
      <Grid container spacing={1} sx={{ mb: 10 }}>
        <FieldAssign name={identificationName} />
      </Grid>

      {adolescente && adolescente.documentos && adolescente.documentos.length > 0 && (
        <Grid item xs={12} sx={{ mb: 2 }}>
          <AttachedFileGroup data={adolescente.documentos} />
        </Grid>
      )}
    </>
  )
}

export default HearingSummary
